module.exports = __webpack_public_path__ + "static/img/banner.018ee32.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/home/jdIndex/banner.jpg
// module id = 1172
// module chunks = 18